export default {
  data() {
    return {};
  },
  methods: {
    addMissionLackOfCodeFunction: function (missionId, stationId) {
      let data = {
        missionId: missionId,
        stationId: stationId,
      };
      this.$store.dispatch('addMissionLackOfCode', data).then(() => {
        if (this.$store.state.missionLackOfCodeModule.successFlag) {
          this.selectedMissionLakeCode = null;
          let temp = this.$store.state.missionLackOfCodeModule.missionLackOfCode;
          this.missionSendInfo.missionLackOfCodes.push(temp);
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionLackOfCodeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addMissionLackOfCodeFunction(missionId, stationId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionLackOfCodeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addMissionLackOfCodeFunction(missionId, stationId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    removeCodeFromMissionLakeOfCodeFunction: function (id) {
      this.$store.dispatch('removeMissionLackOfCode', id).then(() => {
        if (this.$store.state.missionLackOfCodeModule.successFlag) {
          for (let i = 0; i < this.missionSendInfo.missionLackOfCodes.length; i++) {
            if (this.missionSendInfo.missionLackOfCodes[i].id == id) {
              this.missionSendInfo.missionLackOfCodes.splice(i, 1);
            }
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionLackOfCodeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.removeCodeFromMissionLakeOfCodeFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionLackOfCodeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.removeCodeFromMissionLakeOfCodeFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.missionLackOfCodeModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
